import React from 'react'

type Props = {
	onShowFilters: () => void
	onShowSort: () => void
}

const DatatableMobileControl = ({ onShowFilters, onShowSort }: Props) => {
	return (
		<div className="flex lg:hidden mb-4">
			<div className="flex-grow-0 flex-shrink-0 w-1/2 p-2">
				<button onClick={onShowSort} className="bg-primary-400 rounded px-8 py-4 text-white w-full" type="button">
					Sort
				</button>
			</div>
			<div className="flex-grow-0 flex-shrink-0 w-1/2 p-2">
				<button onClick={onShowFilters} className="bg-primary-400 rounded px-8 py-4 text-white w-full" type="button">
					Filter
				</button>
			</div>
		</div>
	)
}

export default DatatableMobileControl
